module.exports = __webpack_public_path__ + "img/lanmu-05.8a614c76.jpg";